const STORAGE_KEY = "beyundai_affiliate_ref";
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

function readStored() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.code || !parsed?.savedAt) return null;
    if (Date.now() - Number(parsed.savedAt) > TTL_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return String(parsed.code).toUpperCase();
  } catch {
    return null;
  }
}

/** Capture ?ref= / ?referral= from the current URL into localStorage (30-day attribution). */
export function captureReferralFromUrl(search = window.location.search) {
  try {
    const params = new URLSearchParams(search);
    const code = String(params.get("ref") || params.get("referral") || "")
      .trim()
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "");
    if (!code || code.length < 4) return readStored();
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ code, savedAt: Date.now() }),
    );
    return code;
  } catch {
    return readStored();
  }
}

export function getStoredReferralCode() {
  return readStored();
}

export function clearStoredReferralCode() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function buildReferralLink(code) {
  const origin =
    typeof window !== "undefined" ? window.location.origin : "https://beyundai.com";
  return `${origin}/user/signup?ref=${encodeURIComponent(code)}`;
}
